<template>
  <svg
    v-if="!extra"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M16.875 7C16.254 7 15.75 6.50222 15.75 5.88889V4.22222H11.25V5.88889C11.25 6.50222 10.746 7 10.125 7C9.504 7 9 6.50222 9 5.88889V4.22222C9 2.99667 10.0091 2 11.25 2H15.75C16.9909 2 18 2.99667 18 4.22222V5.88889C18 6.50222 17.496 7 16.875 7Z"
        :fill="revert ? '#F2F2F2' : color"
      />
      <path
        d="M13.7692 16.9846C13.5742 17.0588 13.2925 17.1118 13 17.1118C12.7075 17.1118 12.4258 17.0588 12.1658 16.9634L0 13V21.0857C0 22.6965 1.3325 24 2.97917 24H23.0208C24.6675 24 26 22.6965 26 21.0857V13L13.7692 16.9846Z"
        :fill="revert ? '#F2F2F2' : color"
      />
      <path
        d="M26 8.05556V10.6L13.26 14.9556C13.1733 14.9889 13.0867 15 13 15C12.9133 15 12.8267 14.9889 12.74 14.9556L0 10.6V8.05556C0 6.36667 1.3325 5 2.97917 5H23.0208C24.6675 5 26 6.36667 26 8.05556Z"
        :fill="revert ? '#F2F2F2' : color"
      />
      <circle cx="23" cy="23" r="7" :fill="revert ? color : '#F2F2F2'" />
      <path
        d="M19 23.5L21.5 26L25.6667 21"
        :stroke="revert ? '#F2F2F2' : color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
  <svg
    v-else
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M16.875 7C16.254 7 15.75 6.50222 15.75 5.88889V4.22222H11.25V5.88889C11.25 6.50222 10.746 7 10.125 7C9.504 7 9 6.50222 9 5.88889V4.22222C9 2.99667 10.0091 2 11.25 2H15.75C16.9909 2 18 2.99667 18 4.22222V5.88889C18 6.50222 17.496 7 16.875 7Z"
        :fill="revert ? '#F2F2F2' : color"
      />
      <path
        d="M13.7692 16.9846C13.5742 17.0588 13.2925 17.1118 13 17.1118C12.7075 17.1118 12.4258 17.0588 12.1658 16.9634L0 13V21.0857C0 22.6965 1.3325 24 2.97917 24H23.0208C24.6675 24 26 22.6965 26 21.0857V13L13.7692 16.9846Z"
        :fill="revert ? '#F2F2F2' : color"
      />
      <path
        d="M26 8.05556V10.6L13.26 14.9556C13.1733 14.9889 13.0867 15 13 15C12.9133 15 12.8267 14.9889 12.74 14.9556L0 10.6V8.05556C0 6.36667 1.3325 5 2.97917 5H23.0208C24.6675 5 26 6.36667 26 8.05556Z"
        :fill="revert ? '#F2F2F2' : color"
      />
      <circle cx="23" cy="23" r="7" :fill="revert ? color : '#F2F2F2'" />
      <path
        d="M23.3333 26.6667V23.3333M23.3333 23.3333V20M23.3333 23.3333H26.6667M23.3333 23.3333H20"
        :stroke="revert ? '#F2F2F2' : color"
        stroke-linecap="round"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconProjectType',
  props: {
    extra: Boolean,
    revert: Boolean,
    color: {
      default: '#277FAF',
      type: String,
    },
  },
}
</script>
